import {axiosGet,axiosPost} from "./axios"

//获取code，静默授权，并跳转首页获取code
function getCode(){
    var APPID="wx62acb935303f0db5";
    var REDIRECT_URI=encodeURIComponent(window.location.href);
    var SCOPE="snsapi_base";
    var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid="+APPID+"&redirect_uri="+REDIRECT_URI+"&response_type=code&scope="+SCOPE+"#wechat_redirect";
return url;
}

//获取openid
function getOpenid(code){
    return axiosPost("/api/h5/get-openid",{"h5Code":code});
}

//获取申请列表
function getHistory(){
    return axiosPost("/api/h5/get-operator-case");
}

//获取案件信息
function getCaseInfo(guid){
    return axiosPost("/api/h5/get-case-info",{"案件GUID":guid});
}

//获取附件文件信息
function getAdditionInfo(guid){
    return axiosPost("/api/h5/get-attachment",{"附件GUID":guid});
}

//创建案件
function buildCase(){
    return axiosPost("/api/h5/new-case");
}

//删除附件
function deleteAddition(case_guid,img_guid){
    return axiosPost("/api/h5/delete-attachment",{"案件GUID":case_guid,"附件GUID":img_guid});
}

//放弃申请
function quitCase(guid){
    return axiosPost("/api/h5/delete-case",{"案件GUID":guid});
}

//提交案件
function submitCase(guid){
    return axiosPost("/api/h5/apply-case",{"案件GUID":guid});
}

//更新案件
function updateCase(caseinfo){
    return axiosPost("/api/h5/update-case-info",caseinfo)
}

//配置接口权限(暂时不用)
function getjssdk(url){
    return axiosPost("/api/h5/get-sdksignature",{"访问URL":url});
}

//上传附件
function uploadAddition(info){
    return axiosPost("/api/h5/upload-attachment",info);
}

//请求预支付
function prePay(guid){
    return axiosPost("/api/h5/get-prepay-info",{"案件GUID":guid})
}

export default {
    getCode,
    getOpenid,
    getHistory,
    getCaseInfo,
    getAdditionInfo,
    buildCase,
    deleteAddition,
    quitCase,
    submitCase,
    updateCase,
    getjssdk,
    uploadAddition,
    prePay
}


// WEBPACK FOOTER //
// ./src/request/api.js